import React, { Component, Fragment } from 'react'
import { Translate } from '../../contexts/Language';
import { BreadCrumb, Card } from '../../components';
import { Config } from '../../config';
import { Service } from '../../services';

export class CryptoQr extends Component {
    constructor(props) {
        super(props)

        this.state = {
            qr: {
                qrCodeImage: null,
                manualEntryKey: null
            },
            success: false,
        }
        this.onVerify = this.onVerify.bind(this);
    }
    componentDidMount() {
        Config.utilities.loadingFetch();

        Service.CryptoService.QrCode().then(response => {

            if (response) {
                if (response.qrCodeImage === null) {
                    window.location.href = '/crypto-wallet';
                }
                this.setState({
                    qr: response
                });
            }
            Config.utilities.loadingFetch();

        });
    }

    onVerify() {
        Config.utilities.loadingFetch();

        Service.CryptoService.QrCodeVerify({ 'code': this.state.code }).then(response => {

            if (response) {
                if (!response.error) {
                    this.setState({
                        success: true
                    });
                }

            }
            Config.utilities.loadingFetch();

        });
    }

    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("QR Code")} Name={Translate("QR Code")} />
                <Card Title="QR Code" Description="BTC QR Code">
                    <div className="row">
                        {this.state.success ?
                            <div className="col-md-12 text-center">
                                <label className="alert alert-info">Your verification was accepted successfully.</label>
                            </div>
                            :
                            this.state.qr.qrCodeImage === null ?
                                ""
                                :
                                <div className="col-md-12 text-center">
                                    <img className="img" src={this.state.qr.qrCodeImage} alt="qrcode" />
                                </div>

                        }

                    </div>
                </Card>
            </Fragment>)
    }
}